import { Box, Breadcrumbs, Button, TextField, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Chip from "@mui/material/Chip";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Grid from "@mui/material/Grid2";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import {
    approveAndRejectApi,
    getAllFilesDownload,
    getBankingApi,
    getFileAndUploadApi,
    getPartnerOverviewApi
} from "../../Services/Partner/Partner";
import {
    CompanyData,
    PartnerData,
    VendorData
} from "./PartnerDetailsInterface";
import { ThreeDot } from "react-loading-indicators";
import pngIcon from "../../../assets/icons/pngIcon.png";
import jpgIcon from "../../../assets/icons/jpgIcon.png";
import pdfIcon from "../../../assets/images/pdfIcon.png";
import { ImgGallery } from "./ImgGallery";
import { showToast } from "../../../Components/Toast";
import defaultlogo from "../../../assets/icons/noimg.png";

import {
    generatePartnerRegistrationFile,
    getLoggedInEmail,
    qualityManager,
    qualityManagerHead,
    sourcingManager,
    sourcingManagerHead
} from "../../../Utils/Constant";
import oligasIcn from "../../../assets/icons/oligas.png";
import evAutoIcn from "../../../assets/icons/automotive.png";
import power from "../../../assets/icons/power.png";
import industry from "../../../assets/icons/industry.png";
import aerospace from "../../../assets/icons/aerospace.png";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
const industryIcons = {
    "Oil & Gas": oligasIcn,
    "Power & Transmission": power,
    "EV/Automotive": evAutoIcn,
    "Industrial Products": industry,
    "Aerospace & Defence": aerospace
};
export const PartnerDetails = () => {
    const location = useLocation();
     const storedData = JSON.parse(
        localStorage.getItem("PartnerDetails") || "null"
    );
    const { partner_Id, navigatingFrom, ID, rfqID, MMrfq } =
        location.state || storedData;
   

    const [value, setValue] = React.useState("1");
    const [openDialog, setOpenDialog] = React.useState(false);
    const [maxWidth, setMaxWidth] =
        React.useState<DialogProps["maxWidth"]>("xs");
    const [overviewData, setOverviewData] = useState<PartnerData[]>([]);
    const [bankingdata, setBankingData] = useState<CompanyData[]>([]);
    const [fileAndUploadData, setFileAndUploadData] = useState<VendorData[]>(
        []
    );
    const [isButtonDisable, setIsButtonDisable] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [bankingLoading, setBankingLoading] = useState<boolean>(false);
    const [fileanduploadLoading, setFileanduploadLoading] =
        useState<boolean>(false);
    const [reasonForRejection, setReasonForRejection] = useState<string>("");
    const navigate = useNavigate();
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setReasonForRejection("");
    };

    const fetchPartnerOverviewData = async () => {
        setLoading(true);
        try {
            const fetchedPartnerOverviewData =
                await getPartnerOverviewApi(partner_Id);

            if (fetchedPartnerOverviewData?.status) {
                setOverviewData(fetchedPartnerOverviewData?.data);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);

            console.log("error while fetching overview data", error);
        }
    };

    const fetchBankingData = async () => {
        setBankingLoading(true);
        try {
            const fetchedPartnerBankingData = await getBankingApi(partner_Id);

            if (fetchedPartnerBankingData?.status) {
                setBankingData(fetchedPartnerBankingData?.data);
            }
            setBankingLoading(false);
        } catch (error) {
            setBankingLoading(false);

            console.log("error while fetching overview data", error);
        }
    };
    const fetchFileAndUploadData = async () => {
        setFileanduploadLoading(true);
        try {
            const fetchedPartnerFileAndUploadData =
                await getFileAndUploadApi(partner_Id);

            if (fetchedPartnerFileAndUploadData?.status) {
                setFileAndUploadData(fetchedPartnerFileAndUploadData?.data);
            }
            setFileanduploadLoading(false);
        } catch (error) {
            setFileanduploadLoading(false);
            console.log("error while fetching overview data", error);
        }
    };
    // const generateUrl = (url: string) => {
    //   if (!url || !partner_Id) {
    //     console.error("Missing URL or partner ID");
    //     return;
    //   }
    //   const downloadUrl = generatePartnerRegistrationFile(url);

    //   const link = document.createElement("a");
    //   link.href = downloadUrl;
    //   link.download = url.split("/").pop() || "certificate.pdf"; // Ensure proper filename
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // };

    const handleAllFilesDownload = async () => {
        setLoading(true);
        try {
            const response = await getAllFilesDownload(
                partner_Id,
                overviewData[0]?.Profile_Info?.Partner_Name
            );
            if (response !== true) {
                showToast({
                    message: "No files found",
                    type: "error"
                });
                // const url = window.URL.createObjectURL(new Blob([response]));
                // const link = document.createElement("a");
                // link.href = url;
                // link.setAttribute("download", `All_Files_${partner_Id}.zip`);
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);

            showToast({
                message: "No files found",
                type: "error"
            });
            console.error("Error while downloading files", error);
        }
    };

    const handleAcceptAndReject = async (status: string) => {
        const payload = [
            {
                partnerId: overviewData[0]?.ID,
                partnerName: overviewData[0]?.Profile_Info?.Partner_Name,
                partnerEmail: "k.yogesh@machinemaze.com",
                partner_status: status,
                reason_for_rejection:
                    status === "Rejected" ? reasonForRejection : "In Review",
                userEmail: getLoggedInEmail(),
                notificationID: overviewData[0]?.Notification_ID
            }
        ];

        try {
            setIsButtonDisable(true);
            const acceptAndRejectData = await approveAndRejectApi(payload);

            if (acceptAndRejectData?.status === true) {
                showToast({
                    message:
                        status === "In Review" || status === "Approved"
                            ? `Partner(s) approved`
                            : `Partner(s) rejected`,
                    type: status === "Rejected" ? "error" : "success"
                });
                navigate("/layout/PartnerDatabase");
                setIsButtonDisable(false);
            } else {
                setIsButtonDisable(false);

                showToast({
                    message: acceptAndRejectData?.message,
                    type: "error"
                });
            }
        } catch (err) {
            showToast({
                message: err?.message,
                type: "error"
            });
        } finally {
            setOpenDialog(false);
            setReasonForRejection(null);
        }
    };
    useEffect(() => {
        // const fetchDataInUseEffect = async () => {
        if (value === "1") {
            fetchPartnerOverviewData();
        } else if (value === "2") {
            fetchBankingData();
        } else if (value === "3") {
            fetchFileAndUploadData();
        }

        // fetchDataInUseEffect();
    }, [value, partner_Id]);
    const getFileIcon = (fileName: string) => {
        const ext = fileName.split(".").pop()?.toLowerCase();

        switch (ext) {
            case "pdf":
                return pdfIcon;
            case "jpg":
            case "jpeg":
                return jpgIcon;
            case "png":
                return pngIcon;
            default:
                return "-"; // Fallback icon for unknown file types
        }
    };
    return (
        <>
            {navigatingFrom === "Partner Database" && (
                <Breadcrumbs
                    aria-label="breadcrumb"
                    sx={{ marginBottom: "10px" }}
                >
                    <Typography sx={{ fontSize: "14px" }}>Home</Typography>
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/PartnerDatabase"
                            state={{
                                rfqData: {
                                    ID: ID,
                                    rfqID: rfqID
                                }
                            }}
                            style={{ color: "#0070BA", textDecoration: "none" }}
                        >
                            {navigatingFrom}
                        </Link>
                    </Typography>
                    <Typography sx={{ fontSize: "14px" }}>
                        Partner Details
                    </Typography>
                </Breadcrumbs>
            )}
            {navigatingFrom === "All MMRFQs" && (
                <Breadcrumbs
                    aria-label="breadcrumb"
                    sx={{ marginBottom: "10px" }}
                >
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/Dashboard"
                            style={{ color: "#0070BA", textDecoration: "none" }}
                        >
                            Home
                        </Link>
                    </Typography>
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/CURFQAssignedToMe"
                            style={{ color: "#0070BA", textDecoration: "none" }}
                        >
                            Assigned CORFQs
                        </Link>
                    </Typography>
                    <Link
                        to="/layout/AllMmrfq"
                        state={{
                            rfqData: {
                                ID: ID,
                                rfqID: rfqID
                            }
                        }}
                        style={{ color: "#0070BA", textDecoration: "none" }}
                    >
                        {navigatingFrom}
                    </Link>

                    <Typography sx={{ fontSize: "14px" }}>
                        Partner Details
                    </Typography>
                </Breadcrumbs>
            )}
            {navigatingFrom === "Proposals" && (
                <Breadcrumbs
                    aria-label="breadcrumb"
                    sx={{ marginBottom: "10px" }}
                >
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/Dashboard"
                            style={{ color: "#0070BA", textDecoration: "none" }}
                        >
                            Home
                        </Link>
                    </Typography>
                    <Typography sx={{ fontSize: "14px" }}>
                        {/* <Link
            to="/layout/CURFQAssignedToMe"
            style={{ color: "#0070BA", textDecoration: "none" }}
          >
            Assigned CORFQs
          </Link> */}
                        {navigatingFrom === "Proposals" ? (
                            <Link
                                to="/layout/Proposals"
                                style={{
                                    color: "#0070BA",
                                    textDecoration: "none"
                                }}
                            >
                                Proposals
                            </Link>
                        ) : (
                            <Link
                                to="/layout/CURFQAssignedToMe"
                                style={{
                                    color: "#0070BA",
                                    textDecoration: "none"
                                }}
                            >
                                Assigned CORFQs
                            </Link>
                        )}
                    </Typography>
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/AllMmrfq"
                            state={{
                                rfqData: {
                                    ID: ID,
                                    rfqID: rfqID
                                }
                            }}
                            style={{ color: "#0070BA", textDecoration: "none" }}
                        >
                            All MMRFQs
                        </Link>
                    </Typography>
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/QuoteCompareData"
                            state={{
                                rfqData: {
                                    ID: MMrfq?.ID,
                                    rfqID: MMrfq?.rfqID,
                                    mmRfqId: MMrfq?.mmRfqId,
                                    mmRfqRowId: MMrfq?.mmRfqRowId,
                                    Part_Row_ID: MMrfq?.Part_Row_ID,
                                    Part_Number: MMrfq?.Part_Number
                                },
                                from: "AllMmrfq"
                            }}
                            style={{ color: "#0070BA", textDecoration: "none" }}
                        >
                            {MMrfq?.mmRfqId}
                        </Link>
                    </Typography>

                    <Typography sx={{ fontSize: "14px" }}>
                        Partner Details
                    </Typography>
                </Breadcrumbs>
            )}

            {overviewData?.map((item) => {
                const logoUrl =
                    item?.Profile_Info?.Partner_logo &&
                    item?.Profile_Info?.Partner_logo !== "N/A"
                        ? generatePartnerRegistrationFile(
                              item?.Profile_Info?.Partner_logo
                          )
                        : defaultlogo;
                return (
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 9, md: 9 }}>
                            <div style={{ display: "flex" }}>
                                <div>
                                    {logoUrl && (
                                        <img
                                            src={logoUrl}
                                            alt="logo"
                                            width={60}
                                            height={60}
                                            style={{
                                                marginRight: "5px",
                                                borderRadius: "50%"
                                            }}
                                        />
                                    )}
                                </div>
                                <div style={{ marginLeft: "10px" }}>
                                    <Typography
                                        variant="h5"
                                        mb={1}
                                        alignItems="normal"
                                        display="flex"
                                    >
                                        {item?.Profile_Info?.Partner_Name}
                                        {item?.Status && (
                                            <Chip
                                                label={item?.Status}
                                                size="small"
                                                color={
                                                    item?.Status === "Approved"
                                                        ? "success"
                                                        : item?.Status ===
                                                            "Rejected"
                                                          ? "error"
                                                          : item?.Status ===
                                                              "New"
                                                            ? "info"
                                                            : "primary"
                                                }
                                                variant="filled"
                                                sx={{
                                                    marginLeft: "10px",
                                                    marginTop: "5px"
                                                }}
                                            />
                                        )}
                                    </Typography>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            mb={1}
                                            color="text.secondary"
                                            sx={{
                                                paddingTop: "0px",
                                                marginBottom: "0px"
                                            }}
                                        >
                                            {item?.Profile_Info?.Partner_ID}
                                        </Typography>
                                        {item?.Audit_Status && (
                                            <>
                                                <Divider
                                                    orientation="vertical"
                                                    sx={{ margin: "0 10px" }}
                                                    variant="middle"
                                                    flexItem
                                                />

                                                <Chip
                                                    label={item?.Audit_Status}
                                                    size="small"
                                                    color={
                                                        item?.Audit_Status ===
                                                        "Physical Audit Pending"
                                                            ? "warning"
                                                            : "success"
                                                    }
                                                    variant="outlined"
                                                    sx={{ marginLeft: "0px" }}
                                                />
                                            </>
                                        )}

                                        <Divider
                                            orientation="vertical"
                                            sx={{ margin: "0 10px" }}
                                            variant="middle"
                                            flexItem
                                        />
                                        <div>
                                            {Array.isArray(
                                                item?.Profile_Info?.Industry
                                            )
                                                ? item?.Profile_Info?.Industry?.map(
                                                      (industry) => (
                                                          <Chip
                                                              key={industry}
                                                              label={industry}
                                                              size="small"
                                                              icon={
                                                                  <img
                                                                      src={
                                                                          industryIcons[
                                                                              industry
                                                                          ]
                                                                      }
                                                                      alt={
                                                                          industry ||
                                                                          "Industry Icon"
                                                                      }
                                                                      width="14px"
                                                                  />
                                                              }
                                                              sx={{
                                                                  padding:
                                                                      "0 4px",
                                                                  marginRight:
                                                                      "5px",
                                                                  marginBottom:
                                                                      "4px",
                                                                  marginTop:
                                                                      "2px"
                                                              }}
                                                          />
                                                      )
                                                  )
                                                : null}
                                        </div>
                                    </Box>
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 3, md: 3 }}>
                            {(sourcingManagerHead() &&
                                overviewData[0].Status === "New") ||
                            ((qualityManager() || qualityManagerHead()) &&
                                overviewData[0].Status === "In Review") ? (
                                <div style={{ float: "right" }}>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        size="small"
                                        disabled={isButtonDisable}
                                        onClick={handleClickOpenDialog}
                                        sx={{ marginRight: "10px" }}
                                    >
                                        Reject
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        disabled={isButtonDisable}
                                        onClick={() =>
                                            handleAcceptAndReject(
                                                sourcingManagerHead()
                                                    ? "In Review"
                                                    : "Approved"
                                            )
                                        }
                                    >
                                        Approve
                                    </Button>
                                    <Dialog
                                        open={openDialog}
                                        onClose={handleCloseDialog}
                                        maxWidth={maxWidth}
                                        fullWidth
                                        aria-labelledby="responsive-dialog-title"
                                    >
                                        <DialogTitle id="responsive-dialog-title">
                                            {"Reason for Rejection"}
                                        </DialogTitle>
                                        <div style={{ padding: "0 20px" }}>
                                            <TextField
                                                id="outlined-multiline-static"
                                                label="Add your comments"
                                                multiline
                                                rows={4}
                                                value={reasonForRejection}
                                                onChange={(e) =>
                                                    setReasonForRejection(
                                                        e?.target?.value
                                                    )
                                                }
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                fullWidth
                                            />
                                        </div>
                                        <DialogActions>
                                            <Button
                                                autoFocus
                                                color="error"
                                                onClick={handleCloseDialog}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                disabled={
                                                    reasonForRejection?.length <=
                                                        0 || isButtonDisable
                                                }
                                                onClick={() =>
                                                    handleAcceptAndReject(
                                                        "Rejected"
                                                    )
                                                }
                                                autoFocus
                                            >
                                                {!isButtonDisable
                                                    ? "Submit"
                                                    : "Submitting"}
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </div>
                            ) : null}
                        </Grid>
                    </Grid>
                );
            })}

            <Box sx={{ width: "100%", typography: "body1" }} mt={2}>
                <TabContext value={value}>
                    <Box>
                        <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                        >
                            <Tab label="Overview" value="1" />
                            <Tab label="Banking & Operations" value="2" />
                            <Tab label="Files & Uploads" value="3" />
                        </TabList>
                    </Box>
                    <Box
                        sx={{
                            borderRadius: "5px",
                            marginTop: "16px",
                            background: "#fff",
                            padding: "0px"
                        }}
                    >
                        {!isButtonDisable && !loading ? (
                            overviewData?.map((item) => {
                                return (
                                    <TabPanel value="1">
                                        {/* Basic Details */}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ mb: 2 }}
                                        >
                                            Basic Details
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Partner name
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {
                                                        item?.Basic_Information
                                                            ?.Legal_Name_of_Business
                                                    }
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Principal place of business
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item?.Basic_Information
                                                        ?.Principal_Place_of_Business ||
                                                        "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    City
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item?.Basic_Information
                                                        ?.City || "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    State
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item?.Basic_Information
                                                        ?.State || "-"}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ my: 2 }} />
                                        {/*Contact Info*/}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ mb: 2 }}
                                        >
                                            Contact Info
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        size={{ xs: 6, md: 6 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Primary contact
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 6, md: 6 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Contact_Information
                                                                ?.Primary_Contact_Name ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 6, md: 6 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Phone
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 6, md: 6 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Contact_Information
                                                                ?.Primary_Contact_Phone ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 6, md: 6 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Email
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 6, md: 6 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                wordBreak:
                                                                    "break-all"
                                                            }}
                                                        >
                                                            {item
                                                                ?.Contact_Information
                                                                ?.Primary_Contact_Email ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 6, md: 6 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Role
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 6, md: 6 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Contact_Information
                                                                ?.Role_in_the_Company ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        size={{ xs: 4, md: 4 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Secondary contact
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 8, md: 8 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Contact_Information
                                                                ?.Secondary_Contact_Name ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 4, md: 4 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Phone
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 8, md: 8 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Contact_Information
                                                                ?.Secondary_Contact_Phone ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 4, md: 4 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Email
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 8, md: 8 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Contact_Information
                                                                ?.Secondary_Contact_Email ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 4, md: 4 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Role
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 8, md: 8 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Contact_Information
                                                                ?.Role_in_the_Company_secondary ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ my: 2 }} />
                                        {/* Solutions Offered */}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ mb: 2 }}
                                        >
                                            Solutions Offered
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Solutions
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                {item?.Solutions_Offered
                                                    ?.Solutions_You_Offer
                                                    ?.length > 0
                                                    ? item.Solutions_Offered.Solutions_You_Offer.map(
                                                          (solution, index) => (
                                                              <Chip
                                                                  key={index}
                                                                  label={
                                                                      solution
                                                                  }
                                                                  size="small"
                                                                  sx={{
                                                                      marginRight:
                                                                          "5px",
                                                                      marginBottom:
                                                                          "5px"
                                                                  }}
                                                              />
                                                          )
                                                      )
                                                    : "-"}
                                            </Grid>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Processes
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item?.Solutions_Offered
                                                        ?.Processes_Offered
                                                        ?.length > 0
                                                        ? item?.Solutions_Offered?.Processes_Offered?.map(
                                                              (
                                                                  processes,
                                                                  index
                                                              ) => (
                                                                  <Chip
                                                                      label={
                                                                          processes
                                                                      }
                                                                      size="small"
                                                                      key={
                                                                          index
                                                                      }
                                                                      sx={{
                                                                          marginRight:
                                                                              "5px",
                                                                          marginBottom:
                                                                              "5px"
                                                                      }}
                                                                  />
                                                              )
                                                          )
                                                        : "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Sub processes
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item?.Solutions_Offered
                                                        ?.Sub_Processes_you_Offer
                                                        ?.length > 0
                                                        ? item.Solutions_Offered.Sub_Processes_you_Offer.map(
                                                              (
                                                                  subProcess,
                                                                  index
                                                              ) => (
                                                                  <Chip
                                                                      key={
                                                                          index
                                                                      }
                                                                      label={
                                                                          subProcess
                                                                      }
                                                                      size="small"
                                                                      sx={{
                                                                          marginRight:
                                                                              "5px",
                                                                          marginBottom:
                                                                              "5px"
                                                                      }}
                                                                  />
                                                              )
                                                          )
                                                        : "-"}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ my: 2 }} />
                                        {/* Solutions Offered */}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ mb: 2 }}
                                        >
                                            Services and capabilities
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 12, md: 12 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Machines Available
                                                </Typography>
                                                {item?.Services_and_Capabilities
                                                    ?.List_of_Top_machines
                                                    ?.length > 0 ? (
                                                    <TableContainer
                                                        component={Paper}
                                                    >
                                                        <Table aria-label="simple table">
                                                            <TableHead
                                                                sx={{
                                                                    background:
                                                                        "#F4F4F4"
                                                                }}
                                                            >
                                                                <TableRow>
                                                                    <TableCell>
                                                                        <b>
                                                                            Machine
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            Size
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            Quantity
                                                                        </b>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {item.Services_and_Capabilities.List_of_Top_machines.map(
                                                                    (
                                                                        machine: any,
                                                                        index: number
                                                                    ) => (
                                                                        <TableRow
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <TableCell>
                                                                                {machine.Machine_category ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Size ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Quantity ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                ) : (
                                                    "-"
                                                )}
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 12 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Instrumentation
                                                </Typography>
                                                {item?.Services_and_Capabilities
                                                    ?.List_of_Instruments
                                                    ?.length > 0 ? (
                                                    <TableContainer
                                                        component={Paper}
                                                    >
                                                        <Table aria-label="simple table">
                                                            <TableHead
                                                                sx={{
                                                                    background:
                                                                        "#F4F4F4"
                                                                }}
                                                            >
                                                                <TableRow>
                                                                    <TableCell>
                                                                        <b>
                                                                            Instrumentation
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            UOM
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            Min
                                                                            Range
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            Max
                                                                            Range
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            Calibrated
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            Due
                                                                            Date
                                                                        </b>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {item.Services_and_Capabilities.List_of_Instruments.map(
                                                                    (
                                                                        machine: any,
                                                                        index: number
                                                                    ) => (
                                                                        <TableRow
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <TableCell>
                                                                                {machine.Instrument_Category ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Unit_of_Measurement ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Range_Min ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Range_Max ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Calibrated ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Due_Date ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                ) : (
                                                    "-"
                                                )}
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 12 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Measuring Equipments
                                                </Typography>
                                                {item?.Services_and_Capabilities
                                                    ?.List_of_Measuring_Equipments
                                                    ?.length > 0 ? (
                                                    <TableContainer
                                                        component={Paper}
                                                    >
                                                        <Table aria-label="simple table">
                                                            <TableHead
                                                                sx={{
                                                                    background:
                                                                        "#F4F4F4"
                                                                }}
                                                            >
                                                                <TableRow>
                                                                    <TableCell>
                                                                        <b>
                                                                            Measuring
                                                                            Equipments
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            UOM
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            Min
                                                                            Range
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            Max
                                                                            Range
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            Calibrated
                                                                        </b>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <b>
                                                                            Due
                                                                            Date
                                                                        </b>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {item?.Services_and_Capabilities?.List_of_Measuring_Equipments?.map(
                                                                    (
                                                                        machine: any,
                                                                        index: number
                                                                    ) => (
                                                                        <TableRow
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <TableCell>
                                                                                {machine.Basic_Instrumentation ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Unit_of_Measurement ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Range_Min ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Range_Max ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Calibrated ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {machine.Due_Date ||
                                                                                    "-"}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                ) : (
                                                    "-"
                                                )}
                                            </Grid>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    No of factories
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item
                                                        ?.Services_and_Capabilities
                                                        ?.No_of_Factories ||
                                                        "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Licensed software
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item
                                                        ?.Services_and_Capabilities
                                                        ?.Any_Licensed_Software
                                                        ?.length > 0
                                                        ? item.Services_and_Capabilities.Any_Licensed_Software.join(
                                                              ", "
                                                          )
                                                        : "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Inventory management
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item
                                                        ?.Services_and_Capabilities
                                                        ?.Do_you_have_any_facilities_for_Inventory_Management ||
                                                        "-"}
                                                </Typography>
                                            </Grid>

                                            {/* <Grid size={{ xs: 3, md: 3 }}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          mb={1}
                        >
                          Engineering design capabilities
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 9, md: 9 }}>
                        <Typography variant="body2">
                          {item?.Services_and_Capabilities
                            ?.Do_you_have_CAD_and_Engineering_Design_Capabilities ||
                            "-"}
                        </Typography>
                      </Grid> */}

                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Material handling capability
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item
                                                        ?.Services_and_Capabilities
                                                        ?.Material_Handling_Capability
                                                        ?.length > 0
                                                        ? item.Services_and_Capabilities.Material_Handling_Capability.join(
                                                              ", "
                                                          )
                                                        : "-"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Printing capabilities
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item
                                                        ?.Services_and_Capabilities
                                                        ?.Printing_Capabilities
                                                        ?.length > 0
                                                        ? item.Services_and_Capabilities.Printing_Capabilities.join(
                                                              ", "
                                                          )
                                                        : "-"}
                                                </Typography>
                                            </Grid>

                                            {/* <Grid size={{ xs: 3, md: 3 }}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          mb={1}
                        >
                          Upload Factory Images
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 9, md: 9 }}>
                        <Typography variant="body2">
                          {item?.Services_and_Capabilities
                            ?.Upload_Factory_Images || "-"}
                        </Typography>
                      </Grid> */}
                                        </Grid>
                                        <Divider sx={{ my: 2 }} />
                                        {/* Solutions Offered */}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ mb: 2 }}
                                        >
                                            Registration Details
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Year of founding
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item?.Registration_Details
                                                        ?.Year_of_Founding ||
                                                        "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    GST number
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item?.Registration_Details
                                                        ?.GST_Number || "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    PAN number
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item?.Registration_Details
                                                        ?.PAN_Number || "-"}
                                                </Typography>
                                            </Grid>

                                            <Grid size={{ xs: 3, md: 3 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    mb={1}
                                                >
                                                    Company website URL
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 9, md: 9 }}>
                                                <Typography variant="body2">
                                                    {item?.Registration_Details
                                                        .Company_URL_Website ||
                                                        "-"}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                );
                            })
                        ) : (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%"
                            >
                                <ThreeDot
                                    color="#1976d2"
                                    size="medium"
                                    text=""
                                    textColor=""
                                />

                                {/* <CircularProgress color="primary" /> */}
                            </Box>
                        )}

                        {!bankingLoading ? (
                            bankingdata?.map((item) => {
                                return (
                                    <TabPanel value="2">
                                        {/*Financial Overview*/}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ mb: 2 }}
                                        >
                                            Financial Overview
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Average company
                                                            turnover
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Finanacial_Overview
                                                                ?.Average_Company_Turnover ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Credit period you
                                                            can offer
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Finanacial_Overview
                                                                ?.Credit_Period_you_can_Offer ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Number of active
                                                            customers
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Finanacial_Overview
                                                                ?.Number_of_Active_Customers ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            List of top
                                                            customers
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item?.Finanacial_Overview?.List_of_Top_Customers?.split(
                                                                " "
                                                            ).join(", ") || "-"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Do you cater to
                                                            export orders
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Finanacial_Overview
                                                                ?.Do_you_Cater_to_Export_Orders ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            List of countries
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Finanacial_Overview
                                                                ?.List_of_Countries_Exported_to
                                                                ?.length > 0
                                                                ? item?.Finanacial_Overview?.List_of_Countries_Exported_to.join(
                                                                      ", "
                                                                  )
                                                                : "-"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ my: 2 }} />

                                        {/*Banking Information*/}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ mb: 2 }}
                                        >
                                            Banking Information
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Account entity name
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Banking_Information
                                                                ?.Account_Entity_Name ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Account number
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Banking_Information
                                                                ?.Account_Number ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Bank name
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Banking_Information
                                                                ?.Bank_Name ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            IFSC code
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Banking_Information
                                                                ?.IFSC_CODE ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Bank branch address
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Banking_Information
                                                                ?.Bank_Address ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Swift code
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Banking_Information
                                                                ?.SWIFT_CODE ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ my: 2 }} />
                                        {/*Operation*/}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ mb: 2 }}
                                        >
                                            Operational Details
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Number of machine
                                                            operators
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Operational_Details
                                                                ?.Number_of_Machine_Operators ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Number of
                                                            administrative staff
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Operational_Details
                                                                ?.Number_of_Administrative_Staff ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Total No. of shifts
                                                            per day
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Operational_Details
                                                                ?.Total_no_of_shifts_per_day ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Working hours in
                                                            each shift
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Operational_Details
                                                                ?.Total_No_of_Hours_per_shift ||
                                                                "-"}{" "}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Grid container spacing={2}>
                                                    {/* <Grid size={{ xs: 5, md: 5 }}>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              mb={1}
                            >
                              Total Working Hours
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 7, md: 7 }}>
                            <Typography variant="body2">
                              {item?.Operational_Details
                                ?.Total_No_of_Hours_per_shift || "-"}
                            </Typography>
                          </Grid> */}
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Total factory size
                                                            in sqft
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Operational_Details
                                                                ?.Total_factory_size_in_sqft ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 5, md: 5 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Any expansion plans
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 7, md: 7 }}
                                                    >
                                                        <Typography variant="body2">
                                                            {item
                                                                ?.Operational_Details
                                                                ?.Any_Expansion_Plans_Optional ||
                                                                "-"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                );
                            })
                        ) : (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%"
                            >
                                <ThreeDot
                                    color="#1976d2"
                                    size="medium"
                                    text=""
                                    textColor=""
                                />

                                {/* <CircularProgress color="primary" /> */}
                            </Box>
                        )}
                        {!fileanduploadLoading ? (
                            fileAndUploadData?.map((item) => {
                                const extension =
                                    item?.Company_Details?.Upload_Brochure?.substring(
                                        item?.Company_Details?.Upload_Brochure?.lastIndexOf(
                                            "."
                                        ) + 1
                                    );
                                const Company_Broucher = `Company_Broucher.${extension}`;
                                const checkLeaveExtension =
                                    item?.Banking_Authorisation_Details.Upload_Cancelled_Cheque?.substring(
                                        item?.Banking_Authorisation_Details.Upload_Cancelled_Cheque?.lastIndexOf(
                                            "."
                                        ) + 1
                                    );
                                const Cancelled_Cheque = `Cancelled_Cheque.${checkLeaveExtension}`;
                                const originalFileName =
                                    item?.Banking_Authorisation_Details
                                        ?.Signed_PDF_Copy || "";
                                const signedNDAExtension =
                                    originalFileName
                                        .split(".")
                                        .pop()
                                        ?.toLowerCase() || "pdf";
                                const Signed_PDF_Copy = `Signed_PDF_Copy.${signedNDAExtension}`;
                                const imageUrl =
                                    generatePartnerRegistrationFile(
                                        item?.Company_Details
                                            ?.Upload_Factory_Images
                                    );
                                return (
                                    <TabPanel value="3">
                                        {/*Company Details*/}
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between"
                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                fontWeight="bold"
                                                sx={{ mb: 2 }}
                                            >
                                                Company Details
                                            </Typography>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                style={{ height: "35px" }}
                                                onClick={handleAllFilesDownload}
                                            >
                                                Download All Files
                                            </Button>
                                        </div>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 12, md: 12 }}>
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        size={{ xs: 3, md: 3 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Company brochure
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 9, md: 9 }}
                                                    >
                                                        {item?.Company_Details
                                                            ?.Upload_Brochure ? (
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    display:
                                                                        "flex",
                                                                    cursor: "pointer"
                                                                }}
                                                                onClick={() => {
                                                                    const fileUrl =
                                                                        generatePartnerRegistrationFile(
                                                                            item
                                                                                ?.Company_Details
                                                                                ?.Upload_Brochure
                                                                        );

                                                                    if (
                                                                        fileUrl
                                                                    ) {
                                                                        const link =
                                                                            document.createElement(
                                                                                "a"
                                                                            );
                                                                        link.href =
                                                                            fileUrl;
                                                                        link.download =
                                                                            fileUrl
                                                                                .split(
                                                                                    "/"
                                                                                )
                                                                                .pop() ||
                                                                            Company_Broucher;
                                                                        document.body.appendChild(
                                                                            link
                                                                        );
                                                                        link.click();
                                                                        document.body.removeChild(
                                                                            link
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                <img
                                                                    src={getFileIcon(
                                                                        extension
                                                                    )}
                                                                    alt="logo"
                                                                    style={{
                                                                        width: "20px",
                                                                        marginRight:
                                                                            "5px"
                                                                    }}
                                                                />
                                                                {
                                                                    Company_Broucher
                                                                }
                                                            </Typography>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 3, md: 3 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Factory images
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        size={{ xs: 9, md: 9 }}
                                                    >
                                                        {imageUrl && (
                                                            <ImgGallery
                                                                imageSrc={
                                                                    imageUrl
                                                                }
                                                            />
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ my: 2 }} />
                                        {/*Compliance Details*/}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ mb: 2 }}
                                        >
                                            Compliance Details
                                        </Typography>
                                        {item?.Certification_Details
                                            ?.Certifications?.length > 0
                                            ? item?.Certification_Details?.Certifications?.map(
                                                  (element, index) => {
                                                      const extension =
                                                          element?.fileName?.substring(
                                                              element?.fileName?.lastIndexOf(
                                                                  "."
                                                              ) + 1
                                                          );

                                                      const Certifications = `${element?.Certification_Name}.${extension}`;

                                                      return (
                                                          <Grid
                                                              container
                                                              spacing={2}
                                                          >
                                                              <Grid
                                                                  size={{
                                                                      xs: 12,
                                                                      md: 12
                                                                  }}
                                                              >
                                                                  {element?.fileName ? (
                                                                      <Grid
                                                                          container
                                                                          spacing={
                                                                              2
                                                                          }
                                                                      >
                                                                          <Grid
                                                                              size={{
                                                                                  xs: 3,
                                                                                  md: 3
                                                                              }}
                                                                          >
                                                                              <Typography
                                                                                  variant="body2"
                                                                                  color="text.secondary"
                                                                                  mb={
                                                                                      1
                                                                                  }
                                                                              >
                                                                                  Certifications{" "}
                                                                                  {index +
                                                                                      1}
                                                                              </Typography>
                                                                          </Grid>
                                                                          <Grid
                                                                              size={{
                                                                                  xs: 9,
                                                                                  md: 9
                                                                              }}
                                                                              onClick={() => {
                                                                                  const fileUrl =
                                                                                      generatePartnerRegistrationFile(
                                                                                          element?.fileName
                                                                                      );

                                                                                  if (
                                                                                      fileUrl
                                                                                  ) {
                                                                                      const link =
                                                                                          document.createElement(
                                                                                              "a"
                                                                                          );
                                                                                      link.href =
                                                                                          fileUrl;
                                                                                      link.download =
                                                                                          fileUrl
                                                                                              .split(
                                                                                                  "/"
                                                                                              )
                                                                                              .pop() ||
                                                                                          Company_Broucher;
                                                                                      document.body.appendChild(
                                                                                          link
                                                                                      );
                                                                                      link.click();
                                                                                      document.body.removeChild(
                                                                                          link
                                                                                      );
                                                                                  }
                                                                              }}
                                                                          >
                                                                              <Typography
                                                                                  variant="body2"
                                                                                  sx={{
                                                                                      display:
                                                                                          "flex",
                                                                                      cursor: "pointer"
                                                                                  }}
                                                                              >
                                                                                  <img
                                                                                      alt="logo"
                                                                                      src={getFileIcon(
                                                                                          extension
                                                                                      )}
                                                                                      style={{
                                                                                          width: "20px",
                                                                                          marginRight:
                                                                                              "5px"
                                                                                      }}
                                                                                  />
                                                                                  {
                                                                                      Certifications
                                                                                  }
                                                                              </Typography>
                                                                          </Grid>
                                                                      </Grid>
                                                                  ) : (
                                                                      "-"
                                                                  )}
                                                              </Grid>
                                                          </Grid>
                                                      );
                                                  }
                                              )
                                            : "-"}

                                        <Divider sx={{ my: 2 }} />
                                        {/*Banking & Authorization*/}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{ mb: 2 }}
                                        >
                                            Banking & Authorization
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid size={{ xs: 12, md: 12 }}>
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        size={{ xs: 3, md: 3 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Cancelled cheque
                                                            leaf
                                                        </Typography>
                                                    </Grid>

                                                    <Grid
                                                        size={{ xs: 9, md: 9 }}
                                                        // onClick={(event) => {
                                                        //   event.preventDefault();
                                                        //   event.stopPropagation();
                                                        //   generateUrl(
                                                        //     item?.Banking_Authorisation_Details
                                                        //       ?.Upload_Cancelled_Cheque,
                                                        //     "Upload_Cancelled_Cheque"
                                                        //   );
                                                        // }}
                                                        onClick={() => {
                                                            const fileUrl =
                                                                generatePartnerRegistrationFile(
                                                                    item
                                                                        ?.Banking_Authorisation_Details
                                                                        ?.Upload_Cancelled_Cheque
                                                                );

                                                            if (fileUrl) {
                                                                const link =
                                                                    document.createElement(
                                                                        "a"
                                                                    );
                                                                link.href =
                                                                    fileUrl;
                                                                link.download =
                                                                    fileUrl
                                                                        .split(
                                                                            "/"
                                                                        )
                                                                        .pop() ||
                                                                    Company_Broucher;
                                                                document.body.appendChild(
                                                                    link
                                                                );
                                                                link.click();
                                                                document.body.removeChild(
                                                                    link
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        {item
                                                            ?.Banking_Authorisation_Details
                                                            ?.Upload_Cancelled_Cheque ? (
                                                            <Typography variant="body2">
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        display:
                                                                            "flex",
                                                                        cursor: "pointer"
                                                                    }}
                                                                >
                                                                    <img
                                                                        alt="logo"
                                                                        src={getFileIcon(
                                                                            checkLeaveExtension
                                                                        )}
                                                                        style={{
                                                                            width: "20px",
                                                                            marginRight:
                                                                                "5px"
                                                                        }}
                                                                    />
                                                                    {
                                                                        Cancelled_Cheque
                                                                    }
                                                                </Typography>
                                                            </Typography>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </Grid>

                                                    <Grid
                                                        size={{ xs: 3, md: 3 }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            mb={1}
                                                        >
                                                            Signed NDA pdf
                                                        </Typography>
                                                    </Grid>

                                                    <Grid
                                                        size={{ xs: 9, md: 9 }}
                                                        onClick={() => {
                                                            const fileUrl =
                                                                generatePartnerRegistrationFile(
                                                                    item
                                                                        ?.Banking_Authorisation_Details
                                                                        ?.Signed_PDF_Copy
                                                                );

                                                            if (fileUrl) {
                                                                const link =
                                                                    document.createElement(
                                                                        "a"
                                                                    );
                                                                link.href =
                                                                    fileUrl;
                                                                link.download =
                                                                    fileUrl
                                                                        .split(
                                                                            "/"
                                                                        )
                                                                        .pop() ||
                                                                    Company_Broucher;
                                                                document.body.appendChild(
                                                                    link
                                                                );
                                                                link.click();
                                                                document.body.removeChild(
                                                                    link
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        {item
                                                            ?.Banking_Authorisation_Details
                                                            ?.Signed_PDF_Copy ? (
                                                            <Typography variant="body2">
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        display:
                                                                            "flex",
                                                                        cursor: "pointer"
                                                                    }}
                                                                >
                                                                    <img
                                                                        alt="logo"
                                                                        src={getFileIcon(
                                                                            signedNDAExtension
                                                                        )}
                                                                        style={{
                                                                            width: "20px",
                                                                            marginRight:
                                                                                "5px"
                                                                        }}
                                                                    />
                                                                    {
                                                                        Signed_PDF_Copy
                                                                    }
                                                                </Typography>
                                                            </Typography>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                );
                            })
                        ) : (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%"
                            >
                                <ThreeDot
                                    color="#1976d2"
                                    size="medium"
                                    text=""
                                    textColor=""
                                />
                            </Box>
                        )}
                    </Box>
                </TabContext>
            </Box>
        </>
    );
};
